// デフォルトアイコンURL
export const defaultIconUrl = '/images/common/user_noimage.png';

// 汎用的拡張子
export const genericExtension = [
  'asc',
  'asp',
  'bat',
  'cf',
  'cgi',
  'clj',
  'cnf',
  'coffee',
  'conf',
  'csv',
  'd',
  'dat',
  'erl',
  'fs',
  'hs',
  'htm',
  'json',
  'log',
  'md',
  'mht',
  'nako3',
  'pm',
  'properties',
  'scm',
  'sh',
  'shtml',
  'sjis',
  'svg',
  'tcl',
  'tex',
  'txt',
  'vbs',
  'xhtml',
  'xml',
  'xsl',
  'yaml',
]

// セキュリティチェック用
export const securityCheck = {
  // 共通ファイル
  common: [
    "ACCESS_KEY", "ACCESSKEY",
    "PASSWORD",
  ],
  // 個別ファイル
  individual: [
    {
      extension: ".html",
      word : [
        "TEST",
        "DUMMY",
      ],
    },
    {
      extension: ".css",
      word : [
        "ACC",
        "PASS",
      ],
    },
  ],
}

// 画面一覧
export interface Screen {
  screenId: string;
  path: string; // パラメータ部分は「*」
  isPram: boolean;
  bind: string; // 複数場合、カンマ区切り
}
export const screen = [
  { screenId: "SC001", path: "/", isPram: false, bind: "" },
  { screenId: "SC002", path: "/login", isPram: false, bind: "" },
  { screenId: "SC003", path: "/password/reissue", isPram: false, bind: "" },
  { screenId: "SC004", path: "/password/resetting/*", isPram: true, bind: "id" },
  { screenId: "SC005", path: "/signup", isPram: false, bind: "" },
  { screenId: "SC006", path: "/validate/*", isPram: true, bind: "id" },
  { screenId: "SC007", path: "/search", isPram: false, bind: "" },
  { screenId: "SC008", path: "/review/*", isPram: true, bind: "dealId" },
  { screenId: "SC009", path: "/review/*/edit", isPram: true, bind: "dealId" },
  { screenId: "SC010", path: "/review/*/confirm", isPram: true, bind: "dealId" },
  { screenId: "SC011", path: "/review/*/payout", isPram: true, bind: "dealId" },
  { screenId: "SC012", path: "/review/draft", isPram: false, bind: "" },
  { screenId: "SC013", path: "/review/confirm", isPram: false, bind: "" },
  { screenId: "SC014", path: "/review/payout", isPram: false, bind: "" },
  { screenId: "SC015", path: "/mypage", isPram: false, bind: "" },
  { screenId: "SC016", path: "/mypage/deals", isPram: false, bind: "" },
  { screenId: "SC017", path: "/mypage/payouts", isPram: false, bind: "" },
  { screenId: "SC018", path: "/mypage/settings", isPram: false, bind: "" },
  { screenId: "SC019", path: "/deal/*", isPram: true, bind: "dealId" },
  { screenId: "SC020", path: "/about", isPram: false, bind: "" },
  { screenId: "SC021", path: "/profile/*", isPram: true, bind: "userId" },
  { screenId: "SC022", path: "/guide", isPram: false, bind: "" },
  { screenId: "SC023", path: "/guide/accept/deal", isPram: false, bind: "" },
  { screenId: "SC024", path: "/guide/accept/confirm", isPram: false, bind: "" },
  { screenId: "SC025", path: "/guide/accept/transfer", isPram: false, bind: "" },
  { screenId: "SC026", path: "/guide/review", isPram: false, bind: "" },
  { screenId: "SC027", path: "/guide/review/deal", isPram: false, bind: "" },
  { screenId: "SC028", path: "/guide/review/edit", isPram: false, bind: "" },
  { screenId: "SC029", path: "/guide/settings", isPram: false, bind: "" },
  { screenId: "SC030", path: "/guide/settings/theme", isPram: false, bind: "" },
  { screenId: "SC031", path: "/guide/settings/mailaddress", isPram: false, bind: "" },
  { screenId: "SC032", path: "/guide/settings/password", isPram: false, bind: "" },
  { screenId: "SC033", path: "/guide/settings/leave", isPram: false, bind: "" },
  { screenId: "SC034", path: "/guide/settings/twoFactor", isPram: false, bind: "" },
  { screenId: "SC035", path: "/announcements", isPram: false, bind: "" },
  { screenId: "SC036", path: "/announcements/*", isPram: true, bind: "id" },
  { screenId: "SC037", path: "/faq", isPram: false, bind: "" },
  { screenId: "SC038", path: "/contact", isPram: false, bind: "" },
  { screenId: "SC039", path: "", isPram: false, bind: "" },
  { screenId: "SC040", path: "", isPram: false, bind: "" },
  { screenId: "SC041", path: "", isPram: false, bind: "" },
  { screenId: "SC042", path: "", isPram: false, bind: "" },
  { screenId: "SC043", path: "/tender/*", isPram: true, bind: "dealId" },
] as Screen[]

/**
 * アクセストークン更新APIのURI
 */
export const REFRESH_ACCESS_TOKEN_ENDPOINT = "/api/auth/refresh";